import { Badge, Space, message } from "antd";
import Cookies from "js-cookie";
import React, { useCallback, useEffect, useState } from "react";

import jwt_decode from "jwt-decode";
import { AiOutlineSearch } from "react-icons/ai";
import { GrCircleInformation, GrNotification } from "react-icons/gr";
import { MdSupport } from "react-icons/md";

import { useSelector } from "react-redux";
import {
  Link,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useWindowSize } from "react-use";
import { login, logout } from "../../redux/auth/actions";
import { selectUser } from "../../redux/auth/selectors";
import { store } from "../../redux/store";
import User from "../../service/User";
import AdminTutorials from "./AdminTutorials";
import Clients from "./Clients";
import AdminUsers from "./Clients/AdminUsers";
import EditGroupPage from "./Clients/EditGroupPage";
import RelatedParties from "./Clients/RelatedParties";
import { default as ClientGroup } from "./Clients/clientByUser";
import ContentManagement from "./ContentManagement";
import DashboardHome from "./DashboardHome";
import DropdownMenu from "./DropdownMenu";
import MultiLoginSelector from "./MultiLoginSelector";
import NotificationManagement from "./NotificationManagement";
import Notifications from "./Notifications/Notifications";
import Plan from "./Plan";
import PlanManagement from "./PlanManagement";
import PlatformStatistics from "./PlatformStatistics";
import Profile from "./Profile";
import Referral from "./Referral";
import SearchEntity from "./SearchEntity";
import SearchUI from "./SearchUI";
import Settings from "./Settings";
import Support from "./Support";
import Team from "./Team";
import UsefulInfo from "./UsefulInfo";
import GeneralInformation from "./GeneralInformation";
import Reports from "./Reports";
import UserDetails from "./UserDetailsPage";
import SuccessPage from "./Plan/SuccessPage";



const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [adminView, setAdminView] = useState(false);
  const [teamView, setTeamView] = useState(false);
  const { width: screenWidth } = useWindowSize();
  const [hasFullClientAccess, setHasFullClientAccess] = useState(false);

  useEffect(() => {
    const accessToken = Cookies.get("accessToken");
    if (accessToken) {
      const decoded = jwt_decode(accessToken);
      setHasFullClientAccess(decoded.hasFullClientAccess);
    }
  }, []);

  const menus = [
    {
      path: "/app/dashboard",
      icon: (
        <>
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.12598 14C8.57002 15.7252 10.1361 17 12 17C13.8638 17 15.4299 15.7252 15.874 14"
              stroke="CurrentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3 10.5651C3 9.9907 3 9.70352 3.07403 9.43905C3.1396 9.20478 3.24737 8.98444 3.39203 8.78886C3.55534 8.56806 3.78202 8.39175 4.23539 8.03912L11.0177 2.764C11.369 2.49075 11.5447 2.35412 11.7387 2.3016C11.9098 2.25526 12.0902 2.25526 12.2613 2.3016C12.4553 2.35412 12.631 2.49075 12.9823 2.764L19.7646 8.03913C20.218 8.39175 20.4447 8.56806 20.608 8.78886C20.7526 8.98444 20.8604 9.20478 20.926 9.43905C21 9.70352 21 9.9907 21 10.5651V17.8C21 18.9201 21 19.4801 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4801 3 18.9201 3 17.8V10.5651Z"
              stroke="CurrentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </>
      ),
      title: "Dashboard",
      display:hasFullClientAccess,
    },
    {
      path: "/app/team",
      icon: (
        <>
          <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.5124 15.7204C17.9502 15.1578 17.2933 14.6986 16.5717 14.3638C17.5892 13.5395 18.2383 12.2817 18.2383 10.8711C18.2383 8.38246 16.1629 6.34076 13.6743 6.37895C11.2238 6.41713 9.24947 8.41391 9.24947 10.8711C9.24947 12.2817 9.90084 13.5395 10.9161 14.3638C10.1944 14.6983 9.53746 15.1576 8.97545 15.7204C7.74908 16.9491 7.05279 18.5707 7.00787 20.3002C7.00727 20.3242 7.01147 20.3481 7.02024 20.3704C7.029 20.3927 7.04214 20.413 7.05888 20.4302C7.07563 20.4474 7.09564 20.461 7.11774 20.4703C7.13984 20.4796 7.16358 20.4844 7.18756 20.4844H8.44537C8.54195 20.4844 8.62281 20.408 8.62506 20.3115C8.66773 19.0087 9.19556 17.7891 10.1232 16.8637C10.5979 16.3865 11.1625 16.0082 11.7844 15.7506C12.4063 15.4931 13.0731 15.3614 13.7461 15.3633C15.114 15.3633 16.401 15.8956 17.3691 16.8637C18.2945 17.7891 18.8223 19.0087 18.8672 20.3115C18.8695 20.408 18.9503 20.4844 19.0469 20.4844H20.3047C20.3287 20.4844 20.3525 20.4796 20.3746 20.4703C20.3967 20.461 20.4167 20.4474 20.4334 20.4302C20.4502 20.413 20.4633 20.3927 20.4721 20.3704C20.4808 20.3481 20.485 20.3242 20.4844 20.3002C20.4395 18.5707 19.7432 16.9491 18.5124 15.7204ZM13.7461 13.7461C12.978 13.7461 12.2547 13.4474 11.7134 12.9038C11.4418 12.6343 11.2272 12.3129 11.0825 11.9586C10.9378 11.6043 10.8659 11.2246 10.8711 10.8419C10.8779 10.1052 11.1721 9.3932 11.6865 8.86537C12.2255 8.31283 12.9465 8.00512 13.717 7.99613C14.4784 7.98939 15.2173 8.28588 15.7609 8.8182C16.3179 9.364 16.6234 10.094 16.6234 10.8711C16.6234 11.6393 16.3247 12.3603 15.7811 12.9038C15.5144 13.1718 15.1973 13.3842 14.848 13.5288C14.4987 13.6734 14.1242 13.7472 13.7461 13.7461ZM8.11969 11.4641C8.09947 11.2687 8.08824 11.071 8.08824 10.8711C8.08824 10.514 8.12193 10.1659 8.18482 9.8267C8.20054 9.74584 8.15787 9.66273 8.08375 9.62904C7.77828 9.49203 7.49752 9.30336 7.25494 9.06527C6.9691 8.78812 6.74417 8.45443 6.59451 8.08549C6.44484 7.71655 6.37373 7.32046 6.3857 6.9225C6.40592 6.2015 6.69566 5.51645 7.20103 4.99984C7.75582 4.43158 8.50152 4.12162 9.29439 4.1306C10.0109 4.13734 10.7027 4.41361 11.226 4.90326C11.4035 5.06947 11.5562 5.25365 11.6842 5.45131C11.7292 5.52094 11.8168 5.55014 11.8931 5.52318C12.2884 5.38617 12.7062 5.28959 13.1352 5.24467C13.261 5.23119 13.3329 5.09643 13.2767 4.98412C12.5467 3.53988 11.0553 2.54262 9.33033 2.51566C6.83941 2.47748 4.76402 4.51918 4.76402 7.00561C4.76402 8.41615 5.41314 9.67396 6.43062 10.4983C5.71636 10.8285 5.05826 11.2844 4.48775 11.8549C3.25689 13.0835 2.5606 14.7052 2.51568 16.437C2.51508 16.4609 2.51929 16.4848 2.52805 16.5071C2.53681 16.5294 2.54995 16.5498 2.5667 16.5669C2.58344 16.5841 2.60345 16.5977 2.62555 16.607C2.64765 16.6163 2.67139 16.6211 2.69537 16.6211H3.95543C4.05201 16.6211 4.13287 16.5448 4.13511 16.4482C4.17779 15.1454 4.70562 13.9258 5.63326 13.0004C6.29361 12.3401 7.1022 11.8819 7.98492 11.6595C8.07252 11.6371 8.13092 11.5539 8.11969 11.4641Z"
              fill="currentColor"
            />
          </svg>
        </>
      ),
      title: "Team",
    },
    {
      path: "/app/clients",
      icon: (
        <>
          <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_46_4)">
              <path
                d="M3.18945 0.561852C2.80312 0.606774 2.51562 0.930211 2.51562 1.31654C2.51562 1.73431 2.85254 2.07123 3.26582 2.07572H8.27012C8.66543 2.07123 8.98437 1.75228 8.98437 1.35697V0.719079C8.98437 0.292321 8.61152 -0.0445932 8.18476 0.00482086L3.18945 0.561852ZM8.51269 3.50873H2.9873C2.91543 3.76478 2.875 4.03431 2.875 4.31283C2.875 5.89857 4.16426 7.18783 5.75 7.18783C7.33574 7.18783 8.625 5.89857 8.625 4.31283C8.625 4.03431 8.58457 3.76478 8.51269 3.50873ZM1.4375 11.5003V12.9378C1.4375 13.7329 2.07988 14.3753 2.875 14.3753H8.625C8.70586 14.3753 8.78223 14.3708 8.85859 14.3574L2.38086 9.37103C1.80137 9.89662 1.4375 10.6558 1.4375 11.5003ZM9.98164 13.4095C10.0311 13.2613 10.0625 13.104 10.0625 12.9378V11.5003C10.0625 9.91459 8.77324 8.62533 7.1875 8.62533H4.3125C4.14629 8.62533 3.98008 8.6388 3.82285 8.66576L9.98164 13.4095ZM17.25 7.18783C18.0125 7.18783 18.7438 6.88493 19.2829 6.34576C19.8221 5.80659 20.125 5.07533 20.125 4.31283C20.125 3.55033 19.8221 2.81906 19.2829 2.2799C18.7438 1.74073 18.0125 1.43783 17.25 1.43783C16.4875 1.43783 15.7562 1.74073 15.2171 2.2799C14.6779 2.81906 14.375 3.55033 14.375 4.31283C14.375 5.07533 14.6779 5.80659 15.2171 6.34576C15.7562 6.88493 16.4875 7.18783 17.25 7.18783ZM15.8125 8.62533C14.2268 8.62533 12.9375 9.91459 12.9375 11.5003V12.9378C12.9375 13.7329 13.5799 14.3753 14.375 14.3753H20.125C20.9201 14.3753 21.5625 13.7329 21.5625 12.9378V11.5003C21.5625 9.91459 20.2732 8.62533 18.6875 8.62533H15.8125ZM9.69414 20.2197C9.92773 20.013 10.0625 19.721 10.0625 19.4066C10.0625 19.0921 9.92773 18.8001 9.69414 18.5935L6.81914 16.0779C6.50019 15.7994 6.05098 15.732 5.66465 15.9072C5.27832 16.0824 5.03125 16.4687 5.03125 16.891V18.3285H1.07812C0.480664 18.3285 0 18.8091 0 19.4066C0 20.004 0.480664 20.4847 1.07812 20.4847H5.03125V21.9222C5.03125 22.3445 5.27832 22.7308 5.66465 22.906C6.05098 23.0812 6.50019 23.0138 6.81914 22.7353L9.69414 20.2197ZM12.9375 19.4021C12.9375 19.712 13.0678 20.0085 13.3014 20.2152L16.1764 22.7488C16.4953 23.0273 16.9445 23.0992 17.3309 22.924C17.7172 22.7488 17.9643 22.3669 17.9643 21.9402V20.4847H21.9174C22.5148 20.4847 22.9955 20.004 22.9955 19.4066C22.9955 18.8091 22.5148 18.3285 21.9174 18.3285H17.9643V16.891C17.9643 16.4687 17.7172 16.0824 17.3309 15.9072C16.9445 15.732 16.4953 15.7994 16.1764 16.0779L13.3014 18.5935C13.0678 18.7956 12.933 19.0921 12.933 19.4021H12.9375Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_46_4">
                <rect width="23" height="23" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </>
      ),
      title: "Client Groups",
    },
    {
      path: "/app/searchEntity",
      icon: (
        <>
          <AiOutlineSearch className="text-xl" />
        </>
      ),
      title: (
        <>
          <Space>
            <div>Screen Entity</div>
          </Space>
        </>
      ),
    },
    {
      path: "/app/reports",
      icon: (
        <>
          <GrCircleInformation className="text-xl" />
        </>
      ),
      title: "Reports",
    },
    {
      path: "/app/generlinfo",
      icon: (
        <>
          <GrCircleInformation className="text-xl" />
        </>
      ),
      title: "General Information",
    },
    {
      path: "/app/support",
      icon: (
        <>
          <MdSupport className="text-xl" />
        </>
      ),
      title: "Support ",
    },
    {
      title: "Referral Program",
      path: "/app/referral",
      icon: (
        <>
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M389 40.84c18.5 0 35 18.79 35 44.03 0 25.33-16.5 44.03-35 44.03s-35-18.7-35-44.03c0-25.24 16.5-44.03 35-44.03zm-132.9 0c18.4 0 35 18.79 35 44.03 0 25.33-16.6 44.03-35 44.03-18.5 0-35.1-18.7-35.1-44.03 0-25.24 16.6-44.03 35.1-44.03zm-133 0c18.5 0 35 18.79 35 44.03 0 25.33-16.5 44.03-35 44.03s-35.09-18.7-35.09-44.03c0-25.24 16.59-44.03 35.09-44.03zm133 109.06c64 2 118 2 182.8 4.2 30.9 17.8 45.2 109 44.3 140.7l-17.6 17.7c-7.7-42.8-17.4-99.9-33.5-112.6v87.6l4.1 183.7H414l-16.7-184.7h-18l-16.7 184.7h-22.3l4.2-183.7-8-88.5h-29.3l-7.2 88.2 4.2 183.7h-22.3l-16.8-184.7h-18l-16.8 184.7h-22.2l4.2-183.7L205 199h-29.3l-8 88.5 4.2 183.7h-22.3l-16.7-184.7h-18L98.01 471.2h-22.2l4.2-183.7v-87.6c-16.2 12.7-25.9 69.8-33.6 112.6l-17.6-17.7c-.9-31.7 13.5-122.9 44.3-140.7 64.99-2.2 118.99-2.2 182.99-4.2z"></path>
          </svg>
        </>
      ),
    },
  
    {
      path: "/app/usermanagement",
      icon: (
        <>
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20"
              stroke="CurrentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12Z"
              stroke="CurrentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </>
      ),
      title: "User Management",
      adminOnly: true,
    },
  
    {
      path: "/app/notificationmanagement",
      icon: (
        <>
          <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_46_18)">
              <path
                d="M3.83325 18.2085V8.62516C3.83325 4.39125 7.266 0.958496 11.4999 0.958496C15.7338 0.958496 19.1666 4.39125 19.1666 8.62516V18.2085M0.958252 18.2085H22.0416M14.3749 18.2085V19.1668C14.3749 20.7548 13.0879 22.0418 11.4999 22.0418C9.91196 22.0418 8.62492 20.7548 8.62492 19.1668V18.2085"
                stroke="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_46_18">
                <rect width="23" height="23" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </>
      ),
      title: "Admin Notifications",
      adminOnly: true,
    },
    {
      path: "/app/contentmanagement",
      icon: (
        <>
          <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.1667 2.875H3.83341C2.77637 2.875 1.91675 3.73462 1.91675 4.79167V18.2083C1.91675 19.2654 2.77637 20.125 3.83341 20.125H19.1667C20.2238 20.125 21.0834 19.2654 21.0834 18.2083V4.79167C21.0834 3.73462 20.2238 2.875 19.1667 2.875ZM3.83341 18.2083V4.79167H10.5417V18.2083H3.83341ZM12.4584 18.2083V4.79167H19.1667L19.1677 18.2083H12.4584Z"
              fill="currentColor"
            />
            <path
              d="M14.375 6.7085H17.25V8.62516H14.375V6.7085ZM14.375 10.5418H17.25V12.4585H14.375V10.5418Z"
              fill="currentColor"
            />
          </svg>
        </>
      ),
      title: "Content Management",
      adminOnly: true,
    },
    {
      title: "Upload Useful Information",
      path: "/app/admin-tutorials",
      adminOnly: true,
      icon: (
        <>
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 16 16"
            height="23"
            width="23"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.5 14.5V11h1v3.5a.5.5 0 0 1-1 0z"
            ></path>
          </svg>
        </>
      ),
    },
  ];
  const fetchLimit = useCallback(async () => {
    User.getLimit().then(({ data }) => {
      if (
        data.limit === 0 &&
        data.adminLimit === 0 &&
        !location.pathname.includes("/plan")
      )
        navigate("/app/plan");
    });
  }, [navigate, location]);
  useEffect(() => {
    fetchLimit();
  }, [fetchLimit]);

  const user = useSelector(selectUser);

  useEffect(() => {
    if (!user) navigate("/");
  }, [user, navigate]);
  useEffect(() => {
    if (user.blocked) {
      navigate("/app/plan");
      message.error(
        "Your subscription is expired. Please renew your subscription"
      );
    }
  }, [navigate, user]);
  useEffect(() => {
    if (!Cookies.get("accessToken")) store.dispatch(logout());
  }, []);

  useEffect(() => {
    setMobileMenu(false);
  }, [screenWidth]);

  const [notifications, setNotifications] = useState([]);
  const [notificationPage, setNotificationPage] = useState(1);
  const [totalPages, settotalPages] = useState(1);

  const markAsRead = async (id) => {
    setNotifications((prev) =>
      prev.map((e) => (e._id === id ? { ...e, status: "read" } : e))
    );
    await User.readnotification(id);
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      console.log(notificationPage);
      const notificationData = await User.getNotifications({
        page: notificationPage,
        limit: 200,
      });
      settotalPages(notificationData?.data?.totalPages);
      setNotifications((prev) => [
        ...prev,
        ...notificationData.data.notifications,
        ...notificationData.data.notificationsReview,
      ]);
    };
    fetchNotifications();
  }, [notificationPage]);
  useEffect(() => {
    const getUserData = async () => {
      const user = await User.me();

      store.dispatch(login(user.data));

      if (user?.data?.role === "admin") {
        setAdminView(true);
      } else if (user?.data?.role === "team_member") {
        setTeamView(true);
      }
    };

    getUserData();
  }, [location]);

  return (
    <div className={`dashboard-wrapper `}>
      <div className="page-wrapper">
        <div className="global-styles w-embed"></div>
        <main className="main-wrapper">
          <div
            data-animation="default"
            className="navbar w-nav"
            data-easing2="ease"
            fs-scrolldisable-element="smart-nav"
            data-easing="ease"
            data-collapse="medium"
            data-w-id="46a1a930-a937-37fe-bcca-d83df445cdbd"
            role="banner"
            data-duration={400}
          >
            <div className="navbar-container">
              <Link
                to="/app/dashboard"
                aria-current="page"
                className="navbar2_logo-link w-nav-brand w--current noselect"
              >
                <img
                  src="/images/Logo_horizontal-p-1080.png"
                  loading="lazy"
                  width={150}
                  alt=""
                  className="navbar2_logo desktop"
                />
              </Link>
              <nav
                role="navigation"
                id="w-node-_46a1a930-a937-37fe-bcca-d83df445cdc2-f445cdbd"
                // className="navbar2_menu is-page-height-tablet w-nav-menu"
              >
                <></>
              </nav>

              <div
                className="mobile-menu-nav !bg-white overflow-hidden transition-all antialiased "
                style={{
                  height: mobileMenu ? "100vh" : "0px",
                  opacity: mobileMenu ? "1" : "0",
                }}
              >
                <div className="side-bar">
                  <div className="w-layout-grid sidebar-menu-grid">
                    <div
                      className="mt-2"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <MultiLoginSelector />
                    </div>
                    {menus
                      .filter((e) => {
                        if (teamView && e.title === "Team") {
                          return false;
                        }
                        if (e.display === false) return false;
                        return adminView ? e : !e?.adminOnly;
                      })
                      .map((menu, i) => (
                        <Link
                          key={i}
                          id="w-node-_80f0ae4c-c804-42b7-43c9-44e38a9444fa-8a9444f8"
                          to={menu.path}
                          aria-current="page"
                          className={`sidebar-menu-item mobile w-inline-block ${
                            location.pathname.includes(menu.path)
                              ? "w--current"
                              : ""
                          }`}
                          onClick={() => setMobileMenu(false)}
                        >
                          <div className="sidemenu-icon w-embed">
                            {menu.icon}
                          </div>
                          <div>{menu.title}</div>
                        </Link>
                      ))}
                  </div>
                </div>
              </div>

              <div
                id="w-node-_46a1a930-a937-37fe-bcca-d83df445cdc9-f445cdbd"
                className="navbar2_button-wrapper"
              >
                <div className="flex items-center gap-5">
                  <SearchUI />
                  <Badge
                    count={
                      notifications?.filter((e) => e.status === "unread").length
                    }
                  >
                    <Link to="/app/notifications">
                      <GrNotification fontSize={22} className="antialiased" />
                    </Link>
                  </Badge>
                  <DropdownMenu />
                </div>
                <div
                  className="navbar2_menu-button w-nav-button"
                  onClick={() => setMobileMenu((e) => !e)}
                >
                  <div className="menu-icon2">
                    <div className="menu-icon2_line-top" />
                    <div className="menu-icon2_line-middle">
                      <div className="menu-icon_line-middle-inner" />
                    </div>
                    <div className="menu-icon2_line-bottom" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <header className="content-wrap">
            <div className="padding-global">
              <div className="container-medium">
                <div className="padding-section-small">
                  <div className="w-layout-grid content-grid">
                    <div
                      id="w-node-_1077fcef-8ece-dd8b-7ff6-718f772a75d0-03a36e81"
                      className="sidebar-content"
                    >
                      <div className="side-bar">
                        <div className="w-layout-grid sidebar-menu-grid">
                          <MultiLoginSelector />

                          {menus
                            .filter((e) => {
                              if (teamView && e.title === "Team") {
                                return false;
                              }

                              if (e.display === false) return false;
                              return adminView ? e : !e?.adminOnly;
                            })
                            .map((menu, i) => (
                              <Link
                                key={i}
                                id="w-node-_80f0ae4c-c804-42b7-43c9-44e38a9444fa-8a9444f8"
                                to={menu.path}
                                aria-current="page"
                                className={`sidebar-menu-item w-inline-block ${
                                  location.pathname.includes(menu.path)
                                    ? "w--current"
                                    : ""
                                }`}
                              >
                                <div className="sidemenu-icon w-embed">
                                  {menu.icon}
                                </div>
                                <div>{menu.title}</div>
                              </Link>
                            ))}
                        </div>
                      </div>
                    </div>
                    <div className=" ">
                      <div className="inner-content">
                        <div className="inner-content-group">
                          <Routes>
                            {(() => {
                              const accessToken = Cookies.get("accessToken");
                              if (!accessToken) return false;
                              const decoded = jwt_decode(accessToken);
                              return decoded.hasFullClientAccess;
                            })() && (
                              <Route
                                path="/dashboard"
                                element={<DashboardHome />}
                              />
                            )}
                            <Route path="/team" element={<Team />} />
                            <Route path="/clients" element={<Clients />} />
                            <Route
                              path="/clients/:groupId"
                              element={<ClientGroup />}
                            />
                            <Route
                              path="/clients/related-parties/:clientId"
                              element={<RelatedParties />}
                            />

                            <Route path="/profile" element={<Profile />} />
                            <Route path="/settings" element={<Settings />} />
                            <Route path="/plan" element={<Plan />} />
                            <Route
                              path="/usermanagement"
                              element={<AdminUsers />}
                            />
                            <Route
                              path="/planmanagement"
                              element={<PlanManagement />}
                            />
                            <Route
                              path="/notificationmanagement"
                              element={<NotificationManagement />}
                            />
                            <Route
                              path="/contentmanagement"
                              element={<ContentManagement />}
                            />
                            <Route
                              path="/userdetails/:userId"
                              element={<UserDetails />}
                            />
                            <Route
                              path="/edit-client-group/:id"
                              element={<EditGroupPage />}
                            />

                            <Route
                              path="/generlinfo"
                              element={<GeneralInformation />}
                            />
                            <Route path="/support" element={<Support />} />
                            <Route path="/success_page" element={<SuccessPage />} />
                            <Route path="/referral" element={<Referral />} />
                            <Route
                              path="/searchEntity"
                              element={<SearchEntity />}
                            />
                            <Route path="/reports" element={<Reports />} />
                            <Route
                              path="/notifications"
                              element={
                                <Notifications
                                  data={notifications}
                                  markAsRead={markAsRead}
                                  settotalPages={settotalPages}
                                  setNotifications={setNotifications}
                                  setNotificationPage={setNotificationPage}
                                  notificationPage={notificationPage}
                                  totalPages={totalPages}
                                />
                              }
                            />

                            <Route
                              path="/platformstatistics"
                              element={<PlatformStatistics />}
                            />

                            {(() => {
                              const accessToken = Cookies.get("accessToken");
                              if (!accessToken) return false;
                              const decoded = jwt_decode(accessToken);
                              return decoded.hasFullClientAccess;
                            })() ? (
                              <Route
                                path="/*"
                                element={<Navigate to="/app/dashboard" />}
                              />
                            ) : (
                              <Route
                                path="/*"
                                element={<Navigate to="/app/clients" />}
                              />
                            )}
                            <Route
                              path="/admin-tutorials"
                              element={<AdminTutorials />}
                            />
                          </Routes>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </main>
      </div>
      <div className="page-wrapper" />
    </div>
  );
};

export default Dashboard;
